import React from 'react';
import { SalesPage } from './pages/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <>
      <FacebookPixel data-id="element-0" />
      <SalesPage data-id="element-1" />
      <PurchasePopup data-id="element-2" />
    </>;
}